import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import loader from 'asset/img/loader.png';

import './Loader.scss';

const Loader = (props) => {
    // Display loader when either Redux loader state is active or manually triggered via isActive prop
    if (props.loader || props?.isActive) {
        return (
            <div className="loaderPageColor">
                <div className="loaderContainer">
                    <div className="loaderAlignCenter">
                        <img className="loaderLogoImg" width="40%" src={loader} alt={'Loader'} />
                        <div className="loaderText">LOADING...</div>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default connect(mapStateToProps, {})(Loader);

function mapStateToProps(state) {
    return {
        loader: state.loader.showLoader,
    };
}

Loader.propTypes = {
    loader: PropTypes.bool,
    isActive: PropTypes.bool,
};
